<template>
    <div class="widget stakee-ad-block">
        <div style="position: relative; z-index: 10;">
            <ui-link v-bind:to="{ name: 'advertise' }" class="stakee-ad-block__sponsored-tag">
                {{ $t('ads.sponsored') }}
            </ui-link>
            <div class="stakee-ad-block__header" v-html="$t(`ads.stakee.title`)" />
            <div class="stakee-ad-block__description" v-html="$t(`ads.stakee.description`)" />
        </div>
        <div>
            <img v-bind:src="bannerIcon" alt="" class="stakee-ad-img" />
            <img v-bind:src="coins1" alt="" class="coins-img-1">
            <img v-bind:src="coins2" alt="" class="coins-img-2">
            <img class="stakee-ad-block__mask-grid" v-bind:src="maskGridUrl" alt="stakee" />
        </div>
        <a v-bind:href="$t(`ads.stakee.link`)" target="_blank" class="stakee-ad-button">{{ $t(`ads.stakee.button`) }}</a>
    </div>
</template>

<script>
import maskGridUrl from '@img/advertise/mask-grid.png';
import bannerIcon from '@img/advertise/stakee/safe.png';
import coins1 from '@img/advertise/stakee/coins1.png';
import coins2 from '@img/advertise/stakee/coins2.png';

export default {
    data() {
        return {
            maskGridUrl,
            coins1,
            coins2,
            bannerIcon,
        };
    },
};
</script>

<style lang="scss">
.stakee-ad-block {
    background: linear-gradient(to right, #1E8DFF, #125599);
    padding: 18px 20px 16px 20px;
    color: white;
    position: relative;
    min-width: 0;
    box-sizing: border-box;

    &__sponsored-tag {
        font-size: 12px;
        font-weight: 500;
        color: white;
        background-color: hsla(0, 0%, 100%, .14);
        display: inline-block;
        border-radius: 5px;
        padding: 2px 6px;
        margin-bottom: 4px;
        text-transform: uppercase;

        &:hover {
            background-color: hsla(0, 0%, 100%, .25);
            text-decoration: none;
        }
    }

    &__mask-grid {
        position: absolute;
        width: auto;
        height: 200px;
        top: 0;
        right: 0;
        z-index: 8;
    }

    &__header {
        font-family: var(--font-heading);
        font-weight: 700;
        font-size: 22px;
        letter-spacing: -0.01em;
        margin-top: 2px;
        margin-bottom: 4px;

        svg {
            width: 22px;
            height: 23px;
            fill: white;
            color: white;
            margin-bottom: -3px;
        }
    }

    &__description {
        max-width: 240px;
        opacity: .9;
        b {
            font-weight: 500;
        }
    }
}

.stakee-ad-img {
    position: absolute;
    width: 94px;
    height: auto;
    top: 25px;
    right: 20px;
    z-index: 20;
    pointer-events: none;
}

.coins-img-1 {
    position: absolute;
    width: 170px;
    height: auto;
    top: 3px;
    right: -3px;
    z-index: 30;
    animation: coins-floating-1 4.5s infinite ease-in-out;
    pointer-events: none;

}

.coins-img-2 {
    position: absolute;
    width: 180px;
    height: auto;
    top: 9px;
    right: -4px;
    z-index: 30;
    animation: coins-floating-2 5.6s infinite ease-in-out;
    pointer-events: none;

}

@keyframes coins-floating-1 {
    from { transform: translateY(0) }
    50% { transform: translateY(3px) }
    to { transform: translateY(0) }
}

@keyframes coins-floating-2 {
    from { transform: translateY(0) }
    50% { transform: translateY(-3px) }
    to { transform: translateY(0) }
}

.stakee-ad-button {
    display: block;
    text-align: center;
    width: 100%;
    background: linear-gradient(to bottom, #fff, #D3E9FF);
    padding: 10px 0;
    border-radius: 8px;
    font-size: 16px;
    margin-top: 15px;
    text-transform: uppercase;
    color: #1E8DFF;
    font-weight: 500;
    font-family: Rubik, Roboto, Ubuntu, Arial, sans-serif;
    cursor: pointer;
    position: relative;
    z-index: 10;

    &:hover {
        background: #f3f3f3;
        text-decoration: none;
    }
}

.widget-stakee-header {
    padding: 24px 20px 16px 20px;
    display: flex;
    align-items: center;
    gap: 14px;
    color: var(--widget-stakee-header-color);
    justify-content: space-between;

    &__logo {
        opacity: .2;
    }

    &__bottom-text {
        font-size: 20px;
        text-transform: uppercase;
        font-weight: 700;
    }

    svg {
        width: auto;
        height: 41px;
    }
}

.widget-subtitle {
    font-size: 24px;
    font-weight: 500;
    margin-top: 15px;
}

.widget-stakee-description {
    padding: 0 20px 7px 20px;
    font-size: 14px;
    line-height: 24px;
}

.widget-stakee-btn {
    display: block;
    text-align: center;
    width: 100%;
    border: none;
    border-radius: 8px;
    color: #FFF;
    background-color: var(--big-blue-button-background);
    padding: 10px 0;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        background-color: var(--big-blue-button-hover-background);
        text-decoration: none;
    }

    &__container {
        padding: 8px 20px 18px 20px;
    }
}
</style>
